(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["blog-cta-system"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialiseBlogCtas = () => {
      const system = document.querySelector('[data-blog-cta-system]');
      const articleBody = document.querySelector('.article-template__content[itemprop="articleBody"]');
      if (!system || !articleBody || system.dataset.initialised === 'true') return;
      system.dataset.initialised = 'true';

      const contentNodes = Array.from(articleBody.children).filter((node) => !node.classList.contains('author-box-container') && !node.matches('style, script'));
      const paragraphs = contentNodes.filter((node) => node.matches('p') && node.textContent.trim().length > 20);
      const headings = contentNodes.filter((node) => node.matches('h2, h3'));
      const h2s = contentNodes.filter((node) => node.matches('h2'));
      const totalTextLength = contentNodes.reduce((sum, node) => sum + node.textContent.trim().length, 0);
      let traversedTextLength = 0;
      let middleHeading = h2s[0] || headings[0];
      let middleHeadingDistance = Number.POSITIVE_INFINITY;
      contentNodes.forEach((node) => {
        traversedTextLength += node.textContent.trim().length;
        if (node.matches('h2')) {
          const distance = Math.abs(traversedTextLength - (totalTextLength / 2));
          if (distance < middleHeadingDistance) {
            middleHeading = node;
            middleHeadingDistance = distance;
          }
        }
      });
      const after = (target, cta) => target && target.parentNode ? target.parentNode.insertBefore(cta, target.nextSibling) : articleBody.appendChild(cta);
      const getHeaderSection = () => document.querySelector('#shopify-section-header');
      const getNavigation = () => document.querySelector('#shopify-section-header sticky-header, #shopify-section-header .header-wrapper, #shopify-section-header, sticky-header, header.header');
      const getNavigationBottom = () => {
        const navigation = getNavigation();
        if (!navigation) return 0;
        if (!window.matchMedia('(max-width: 989px)').matches) return Math.max(0, navigation.getBoundingClientRect().bottom);
        const header = navigation.matches('header.header') ? navigation : navigation.querySelector('header.header');
        if (!header) return Math.max(0, navigation.getBoundingClientRect().bottom);
        const visibleChildren = Array.from(header.children).filter((child) => {
          const style = getComputedStyle(child);
          const rect = child.getBoundingClientRect();
          return style.display !== 'none' && style.visibility !== 'hidden' && rect.height > 0;
        });
        if (!visibleChildren.length) return Math.max(0, header.getBoundingClientRect().bottom);
        return Math.max(0, ...visibleChildren.map((child) => child.getBoundingClientRect().bottom));
      };
      const updateStickyOffset = (cta) => {
        const headerBottom = getNavigationBottom();
        cta.style.setProperty('--blog-cta-header-offset', `${Math.round(headerBottom)}px`);
      };
      const isFooterCta = (cta) => cta.dataset.position === 'mobile_footer' || cta.dataset.position === 'sticky_footer';
      const dismissalKey = (cta) => {
        if (cta.dataset.position === 'sticky_top') return 'blogCtaDismissed:sticky_top:v2';
        if (isFooterCta(cta)) return 'blogCtaDismissed:sticky_footer:v2';
        return `blogCtaDismissed:${cta.dataset.position}`;
      };
      const dismissalStorage = (cta) => isFooterCta(cta) ? sessionStorage : localStorage;
      const wasDismissed = (cta) => {
        const value = dismissalStorage(cta).getItem(dismissalKey(cta));
        if (!value) return false;
        if (isFooterCta(cta)) return value === 'true';
        return Number(value) > Date.now();
      };
      const enableDismissal = (cta) => {
        if (wasDismissed(cta)) {
          cta.closest('#shopify-section-header')?.classList.remove('has-blog-cta-top');
          cta.remove();
          return false;
        }
        const close = cta.querySelector('[data-blog-cta-close]');
        if (close) close.addEventListener('click', () => {
          const value = isFooterCta(cta) ? 'true' : String(Date.now() + (7 * 24 * 60 * 60 * 1000));
          dismissalStorage(cta).setItem(dismissalKey(cta), value);
          if (isFooterCta(cta)) document.body.classList.remove('blog-cta-footer-visible');
          cta.closest('#shopify-section-header')?.classList.remove('has-blog-cta-top');
          cta.remove();
        });
        return true;
      };

      Array.from(system.querySelectorAll('[data-blog-cta]')).forEach((cta) => {
        const position = cta.dataset.position;
        if (position === 'first_paragraph') after(paragraphs[0] || contentNodes[0], cta);
        else if (position === 'inline_top') {
          after(h2s[0] || headings[0] || paragraphs[Math.min(2, paragraphs.length - 1)], cta);
          enableDismissal(cta);
        }
        else if (position === 'inline_middle') {
          after(middleHeading || paragraphs[Math.floor(paragraphs.length / 2)], cta);
          enableDismissal(cta);
        }

        else if (position === 'article_end') {
          articleBody.insertBefore(cta, articleBody.querySelector('.author-box-container'));
          enableDismissal(cta);
        }
        else if (position === 'sticky_top') {
          const headerSection = getHeaderSection();
          if (headerSection) {
            headerSection.appendChild(cta);
            headerSection.classList.add('has-blog-cta-top');
            cta.classList.add('is-nav-tethered');
          } else {
            document.body.appendChild(cta);
          }
          if (!enableDismissal(cta)) return;
          if (!cta.classList.contains('is-nav-tethered')) {
            updateStickyOffset(cta);
            window.addEventListener('resize', () => updateStickyOffset(cta), { passive: true });
            window.addEventListener('scroll', () => updateStickyOffset(cta), { passive: true });
          }
        }
        else if (position === 'mobile_footer' || position === 'sticky_footer') {
          document.body.appendChild(cta);
          if (!enableDismissal(cta)) return;
          const updateFooter = () => {
            const maxScroll = document.documentElement.scrollHeight - innerHeight;
            const progress = maxScroll > 0 ? scrollY / maxScroll : 0;
            const isVisible = progress >= 0.10;
            cta.classList.toggle('is-visible', isVisible);
            document.body.classList.toggle('blog-cta-footer-visible', isVisible);

            if (isVisible) {
              const alignChat = () => {
                const chat = document.querySelector('shopify-chat');
                const activator = chat?.shadowRoot?.querySelector('[part="activator"]');
                if (!chat || !activator) return;
                const currentOffset = parseFloat(window.getComputedStyle(chat).bottom) || 0;
                const targetBottom = cta.getBoundingClientRect().top - 8;
                const nextOffset = currentOffset + activator.getBoundingClientRect().bottom - targetBottom;
                document.documentElement.style.setProperty('--blog-cta-chat-offset', `${Math.max(-32, nextOffset)}px`);
              };
              window.requestAnimationFrame(alignChat);
              window.setTimeout(alignChat, 300);
            }
          };
          updateFooter();
          window.addEventListener('scroll', updateFooter, { passive: true });
          window.addEventListener('resize', updateFooter, { passive: true });
        }
      });
      system.remove();
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialiseBlogCtas);
    else initialiseBlogCtas();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();

      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('ul'),
      };
      
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);

      if (this.classList.contains('on-header')) {
        document.body.classList.remove('localization--open');
      }
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      // this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      // this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());

      if (this.classList.contains('on-header')) {
        document.body.classList.toggle('localization--open');
      }
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }
  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class HeaderWrapper extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');

      this.exitTimer = null;
      this.onEnterHandler = this.onEnter.bind(this);
      this.onLeaveHandler = this.onLeave.bind(this);
      this.addEventListener('mouseenter', this.onEnterHandler);
      this.addEventListener('mouseleave', this.onLeaveHandler);
    }

    disconnectedCallback() {
      this.removeEventListener('mouseenter', this.onEnterHandler);
      this.removeEventListener('mouseleave', this.onLeaveHandler);
    }

    onEnter() {
      this.preventClose = true;
      this.header.classList.add('is-active');
      clearTimeout(this.exitTimer);
    }

    onLeave() {
      this.exitTimer = setTimeout(() => {
        this.header.classList.remove('is-active');
      }, 400);
    }

  }
  customElements.define('header-wrapper', HeaderWrapper);

  class StickyHeader extends HeaderWrapper {
    constructor() {
      super();
    }

    connectedCallback() {
      super.connectedCallback();

      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.scrollUpActive = false;

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      window.addEventListener('scroll', this.onScrollHandler, false);
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);

      this.createObserver();
    }

    disconnectedCallback() {
      super.connectedCallback();

      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;

        if (this.headerBounds.top === 0 && this.headerBounds.bottom === 0) {
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
          const boundingClientRect = entries[0].boundingClientRect;

          this.headerBounds = {
            top: scrollTop + boundingClientRect.top,
            bottom: scrollTop + boundingClientRect.bottom
          };
        }

        if (this.dataset.scrollUp !== undefined) {
          this.scrollUpActive = true;
        }

        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (theme.config.mqlSmall || this.scrollUpActive) {
        if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          requestAnimationFrame(this.hide.bind(this));
        }
        else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          if (!this.preventReveal) {
            requestAnimationFrame(this.reveal.bind(this));
          }
          else {
            window.clearTimeout(this.isScrolling);

            this.isScrolling = setTimeout(() => {
              this.preventReveal = false;
            }, 66);

            requestAnimationFrame(this.hide.bind(this));
          }
        }
        else if (scrollTop <= this.headerBounds.top) {
          requestAnimationFrame(this.reset.bind(this));
        }
      }
      else {
        if (scrollTop > this.headerBounds.bottom) {
          if (this.sticky()) return;
          
          requestAnimationFrame(this.hide.bind(this));

          setTimeout(() => {
            requestAnimationFrame(this.reveal.bind(this));
          }, 100);
        }
        else if (scrollTop <= this.headerBounds.top) {
          requestAnimationFrame(this.reset.bind(this));
        }
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    sticky() {
      return this.header.classList.contains('shopify-section-header-sticky') && !this.header.classList.contains('shopify-section-header-hidden');
    }
  }
  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
